import { Button, BUTTON_THEME, Icon, Switch } from '@st-operations/uikit/src/v2'
import React from 'react'

import './styles.scss'

const EventFeedsWizardDefaultFilters = ({
  onBackClick,
  isSdf,
  onIsSdfChange,
  removeBots,
  onRemoveBotsChange,
  sources,
  onSourcesChange,
  cgActions,
  onCgActionsChange,
  onGoToFeed,
}) => {
  return (
    <div className="event-feeds-wizard-default-filters__container">
      <Button
        theme={BUTTON_THEME.GHOST}
        onClick={onBackClick}
        className="event-feeds-wizard-default-filters__back-button"
      >
        <Icon type="outline" icon="angleleft" />
        Back
      </Button>
      <span className="event-feeds-wizard-default-filters__title">{`7. I'd like to keep these default filters:`}</span>
      <div className="event-feeds-wizard-default-filters__item-container">
        <div className="event-feeds-wizard-default-filters__item">
          <span className="event-feeds-wizard-default-filters__item-title">Is SDF</span>
          <span className="event-feeds-wizard-default-filters__item-operator">Equals</span>
          <span className="event-feeds-wizard-default-filters__item-value">True</span>
          <Switch
            checked={isSdf}
            onChange={(e) => onIsSdfChange(e.target.checked)}
            classes={{ root: 'event-feeds-wizard-default-filters__item-switch' }}
          />
        </div>
        <div className="event-feeds-wizard-default-filters__item">
          <span className="event-feeds-wizard-default-filters__item-title">Remove Bots</span>
          <span className="event-feeds-wizard-default-filters__item-operator">Equals</span>
          <span className="event-feeds-wizard-default-filters__item-value">True</span>
          <Switch
            checked={removeBots}
            onChange={(e) => onRemoveBotsChange(e.target.checked)}
            classes={{ root: 'event-feeds-wizard-default-filters__item-switch' }}
          />
        </div>
        <div className="event-feeds-wizard-default-filters__item">
          <span className="event-feeds-wizard-default-filters__item-title">Sources</span>
          <span className="event-feeds-wizard-default-filters__item-operator">In</span>
          <span className="event-feeds-wizard-default-filters__item-value">ShareThis</span>
          <Switch
            checked={sources}
            onChange={(e) => onSourcesChange(e.target.checked)}
            classes={{ root: 'event-feeds-wizard-default-filters__item-switch' }}
          />
        </div>
        <div className="event-feeds-wizard-default-filters__item">
          <span className="event-feeds-wizard-default-filters__item-title">
            Content Rules (CG Actions)
          </span>
          <span className="event-feeds-wizard-default-filters__item-operator">Not In</span>
          <span className="event-feeds-wizard-default-filters__item-value">blocklist</span>
          <Switch
            checked={cgActions}
            onChange={(e) => onCgActionsChange(e.target.checked)}
            classes={{ root: 'event-feeds-wizard-default-filters__item-switch' }}
          />
        </div>
      </div>
      <div className="event-feeds-wizard-default-filters__go-to-feed-container">
        <Button
          className="event-feeds-wizard-default-filters__go-to-feed-button"
          onClick={onGoToFeed}
        >
          Go to Feed
        </Button>
      </div>
    </div>
  )
}

export default EventFeedsWizardDefaultFilters
